import "./body.css";
import Card from "../card/Card";

const Body = () => {
  let desc1 = "Architected a front-end web page using modular, reusable React components where the user is able to input their guess of a Pokemon of over 700 different pokemon images from the PokeAPI"
  let desc2 = "Guided my team in creating a financial calculator that uses your expenses and income to yield the appropriate results"
  let desc3 = "Created a search field where the user can input the image url of an anime scene. Obtained data asynchronously using axios with Javascript from the trace.moe API providing data for an anime’s name, episode, and time stamp utilizing the image url provided by the user."
  let desc4 = "Architected an endless runner game utilizing the Unity game engine. Implemented game logic, endless object spawning, and a persistent high score tracker with C#"
  let desc5 = "Utilized a map as the data structure to implement an anagram checker."

  return (
    <div className='body-container'>
        <div className='project-header'>
            <h2 className="proj-header">{'>>'} Latest Projects</h2>
            <p className="txt proj-txt">What I'm working on in my free time</p>
        </div>
        <div className="card-layout">
            <Card title={"Whose that pokemon?"} description={desc1} githubLink={"https://github.com/ShifuX/whose-that-pokemon"} 
            tech={"React | Javascript | CSS3"} />
            <Card title={"Hackathon project"} description={desc2} githubLink={"https://github.com/Shinsha-Studios/Hackthon"} 
            tech={"Javascript | CSS3 | HTML5"} />
            <Card title={"Anime finder"} description={desc3} githubLink={"https://github.com/ShifuX/anime-finder"} 
            tech={"React | Javascript | CSS3"} />
            <Card title={"Cube runner"} description={desc4} githubLink={"https://play.unity.com/mg/other/firstgame-webversion"} 
            tech={"C# | Unity"} />
            <Card title={"Anagram solver"} description={desc5} githubLink={"https://github.com/ShifuX/anagram-solver"} 
            tech={"React | Javascript | CSS3"} />
        </div>
    </div>
  )
}

export default Body